angular.module('autoremind.appointments.services', [])
    .factory('appointmentService', ['$rootScope', '$http', '$enhancedHttp', '$q', 'logger', '$rootScope', '$uibModal',
    function ($rootScope, $http, $enhancedHttp, $q, logger, $scope, $uibModal) {
        var service = null;
        service = {
            appointmentsError: '',
            loadingIndicator: {
                refCount: 0,
                state: false
            },
            // NOTE: this will never be called from NGRX version
            // for timelines tab we need this, so just keep it once its decided that we dont need timelines any more
            personsAppointments: {
                inProgress: false,
                last: 0,
                list: [],
                url: '',
                generateUrl: function (patientId) {
                    service.personsAppointments.url = '/servlets/appointments/person/' + patientId + '/?offset=' + service.personsAppointments.last;
                    service.appointmentsError = 'There was an error getting appointments for the given person.';
                },
                getAppointments: function (patientId) {
                    service.personsAppointments.last = 0;
                    service.personsAppointments.generateUrl(patientId);
                    return service.getAppointments(service.personsAppointments);
                },
                getMoreAppointments: function (patientId) {
                    service.personsAppointments.generateUrl(patientId);
                    return service.getMoreAppointments(service.personsAppointments);
                }
            },
            getAppointments: function (model) {
                model.list = [];
                model.last = 0;
                service.previousTime = null;
                logger.debug('appointmentService.getAppointments(offset=' + model.last + ')');
                return service.getMoreAppointments(model);
            },
            previousLast: null,
            previousTime: null,
            /**
             *
             */
            getMoreAppointments: function (model) {
                var deferred = $q.defer();
                if (!model.inProgress) {
                    var now = moment().valueOf();
                    var delta = now - service.previousTime;
                    //logger.debug('appointmentService.getMoreAppointments(offset=' + model.last + ') at millis ' + service.previousTime + ' and previousLast ' + service.previousLast + ' delta ' + delta );
                    if (service.previousTime !== null && delta < 2000 && service.previousLast == model.last) {
                        // Cool down
                        //logger.error('Same number of appointments as last request within short time (cooldown 2s) - ignore request');
                        deferred.reject();
                    }
                    else {
                        logger.debug('appointmentService.getMoreAppointments(offset=' + model.last + ') at millis ' + service.previousTime + ' and previousLast ' + service.previousLast + ' delta ' + delta);
                        service.previousLast = model.last;
                        service.previousTime = now;
                        model.inProgress = true;
                        $enhancedHttp({
                            method: 'GET',
                            headers: { 'Content-Type': 'application/json' },
                            url: model.url,
                            errorMessage: service.appointmentsError,
                            disableErrorDialog: false
                        }, service.loadingIndicator)
                            .then(function (data, status) {
                            for (var i = 0; i < data.appointments.length; i++) {
                                // Only add new elements if not already in the list
                                var alreadyInList = false;
                                for (var j = 0; j < model.list.length; j++) {
                                    if (model.list[j].appointmentId === data.appointments[i].appointmentId) {
                                        alreadyInList = true;
                                        break;
                                    }
                                }
                                if (!alreadyInList) {
                                    data.appointments[i].strategyName = strategiesService.getStrategyNameById(data.appointments[i].strategyId);
                                    model.list.push(data.appointments[i]);
                                }
                                model.last++;
                            }
                            model.inProgress = false;
                            if (angular.isDefined(data.appointmentDate) && data.appointmentDate !== '') {
                                model.date = new Date(data.appointmentDate);
                            }
                            deferred.resolve(data);
                        }, function (data, status) {
                            model.inProgress = false;
                            logger.error('Error getting appointments data from server');
                            deferred.reject(status);
                        });
                    }
                }
                else {
                    //TODO: should we reject promise?
                    logger.debug("skipping - in progress");
                }
                return deferred.promise;
            },
            clearModel: function () {
                service.appointments.last = 0;
                service.appointments.inProgress = false;
                service.appointments.list = [];
                //service.appointments.url = '';
                service.personsAppointments.last = 0;
                service.personsAppointments.inProgress = false;
                service.personsAppointments.list = [];
                //service.personsAppointments.url = '';
                service.appointmentStates = [];
            }
        };
        $rootScope.$on('event:auth-logout', function () {
            logger.debug('appointmentService.clear: killing service data');
            service.clearModel();
        });
        return service;
    }]);
//# sourceMappingURL=appointments.services.js.map